// @flow

import { type OutgoingPayment } from '../outgoing-payment';

export async function externalMexicoOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'externalpayprovider',
    payment_type_code: 'aplazo',
  };
}
